module.exports = __webpack_public_path__ + "static/media/logo.fd89cfca.svg";